import React from 'react';
import Switch from 'react-switch';
import { ToggleButtonProps } from './ToggleButton.types';
import './ToggleButton.scss';

/** A button to toggle something between true and false */
const ToggleButton = ({
    value = false,
    onColour = '#86d3ff',
    onHandleColour = '#2693e6',
    handleDiameter = 25,
    renderUncheckedIcon = false,
    renderCheckedIcon = false,
    onChange,
    label
}: ToggleButtonProps): JSX.Element => {
    const getLabel = () => {
        if (label) {
            return (
                <div
                    className='label'
                    dangerouslySetInnerHTML={{ __html: label }}></div>
            );
        }
        return <></>;
    };

    return (
        <div className='toggle-container'>
            {getLabel()}
            <div className='toggle'>
                <label htmlFor='switch'>
                    <Switch
                        onChange={onChange}
                        checked={value}
                        onColor={onColour}
                        onHandleColor={onHandleColour}
                        handleDiameter={handleDiameter}
                        uncheckedIcon={renderUncheckedIcon}
                        checkedIcon={renderCheckedIcon}
                        boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
                        activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
                        height={20}
                        width={48}
                        className='React-switch'
                    />
                </label>
            </div>
        </div>
    );
};
export default ToggleButton;
